/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type Company,
    CompanyFromJSON,
    CompanyToJSON,
} from '../models/Company';
import {
    type CompanyMembership,
    CompanyMembershipFromJSON,
    CompanyMembershipToJSON,
} from '../models/CompanyMembership';
import {
    type OAuthApplication,
    OAuthApplicationFromJSON,
    OAuthApplicationToJSON,
} from '../models/OAuthApplication';
import {
    type OAuthApplicationCreateRequest,
    OAuthApplicationCreateRequestFromJSON,
    OAuthApplicationCreateRequestToJSON,
} from '../models/OAuthApplicationCreateRequest';
import {
    type OAuthApplicationWithSecret,
    OAuthApplicationWithSecretFromJSON,
    OAuthApplicationWithSecretToJSON,
} from '../models/OAuthApplicationWithSecret';
import {
    type Token,
    TokenFromJSON,
    TokenToJSON,
} from '../models/Token';
import {
    type User,
    UserFromJSON,
    UserToJSON,
} from '../models/User';

export interface AccountsOauthCredentialsCreateRequest {
    oAuthApplicationCreateRequest: OAuthApplicationCreateRequest;
}

export interface AccountsUsersListRequest {
    companymembershipCompany?: number;
    hasApprovalPermission?: boolean;
    ordering?: string;
}

/**
 * 
 */
export class AccountsApi extends runtime.BaseAPI {

    /**
     * Creates request options for accountsCompaniesMyRetrieve without sending the request
     */
    async accountsCompaniesMyRetrieveRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/accounts/companies/my/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns company of current user.
     */
    async accountsCompaniesMyRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Company>> {
        const requestOptions = await this.accountsCompaniesMyRetrieveRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyFromJSON(jsonValue));
    }

    /**
     * Returns company of current user.
     */
    async accountsCompaniesMyRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Company> {
        const response = await this.accountsCompaniesMyRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountsMembershipMyRetrieve without sending the request
     */
    async accountsMembershipMyRetrieveRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/accounts/membership/my/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns membership of current user.
     */
    async accountsMembershipMyRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanyMembership>> {
        const requestOptions = await this.accountsMembershipMyRetrieveRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyMembershipFromJSON(jsonValue));
    }

    /**
     * Returns membership of current user.
     */
    async accountsMembershipMyRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanyMembership> {
        const response = await this.accountsMembershipMyRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountsOauthCredentialsCreate without sending the request
     */
    async accountsOauthCredentialsCreateRequestOpts(requestParameters: AccountsOauthCredentialsCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['oAuthApplicationCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'oAuthApplicationCreateRequest',
                'Required parameter "oAuthApplicationCreateRequest" was null or undefined when calling accountsOauthCredentialsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/accounts/oauth-credentials/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OAuthApplicationCreateRequestToJSON(requestParameters['oAuthApplicationCreateRequest']),
        };
    }

    /**
     * Create the user\'s OAuth application, replacing any existing one.
     */
    async accountsOauthCredentialsCreateRaw(requestParameters: AccountsOauthCredentialsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OAuthApplicationWithSecret>> {
        const requestOptions = await this.accountsOauthCredentialsCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OAuthApplicationWithSecretFromJSON(jsonValue));
    }

    /**
     * Create the user\'s OAuth application, replacing any existing one.
     */
    async accountsOauthCredentialsCreate(requestParameters: AccountsOauthCredentialsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OAuthApplicationWithSecret> {
        const response = await this.accountsOauthCredentialsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountsOauthCredentialsDestroy without sending the request
     */
    async accountsOauthCredentialsDestroyRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/accounts/oauth-credentials/`;

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the user\'s OAuth application and revoke all its tokens.
     */
    async accountsOauthCredentialsDestroyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.accountsOauthCredentialsDestroyRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the user\'s OAuth application and revoke all its tokens.
     */
    async accountsOauthCredentialsDestroy(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.accountsOauthCredentialsDestroyRaw(initOverrides);
    }

    /**
     * Creates request options for accountsOauthCredentialsRegenerateSecretCreate without sending the request
     */
    async accountsOauthCredentialsRegenerateSecretCreateRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/accounts/oauth-credentials/regenerate-secret/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Regenerate the client secret and revoke all existing access tokens.
     */
    async accountsOauthCredentialsRegenerateSecretCreateRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OAuthApplicationWithSecret>> {
        const requestOptions = await this.accountsOauthCredentialsRegenerateSecretCreateRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OAuthApplicationWithSecretFromJSON(jsonValue));
    }

    /**
     * Regenerate the client secret and revoke all existing access tokens.
     */
    async accountsOauthCredentialsRegenerateSecretCreate(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OAuthApplicationWithSecret> {
        const response = await this.accountsOauthCredentialsRegenerateSecretCreateRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountsOauthCredentialsRetrieve without sending the request
     */
    async accountsOauthCredentialsRetrieveRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/accounts/oauth-credentials/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve the user\'s OAuth application (without secret).
     */
    async accountsOauthCredentialsRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OAuthApplication>> {
        const requestOptions = await this.accountsOauthCredentialsRetrieveRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OAuthApplicationFromJSON(jsonValue));
    }

    /**
     * Retrieve the user\'s OAuth application (without secret).
     */
    async accountsOauthCredentialsRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OAuthApplication> {
        const response = await this.accountsOauthCredentialsRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountsTokenCreate without sending the request
     */
    async accountsTokenCreateRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/accounts/token/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Generate or regenerate user\'s token.
     */
    async accountsTokenCreateRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Token>> {
        const requestOptions = await this.accountsTokenCreateRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenFromJSON(jsonValue));
    }

    /**
     * Generate or regenerate user\'s token.
     */
    async accountsTokenCreate(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Token> {
        const response = await this.accountsTokenCreateRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountsTokenRetrieve without sending the request
     */
    async accountsTokenRetrieveRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/accounts/token/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve user\'s token.
     */
    async accountsTokenRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Token>> {
        const requestOptions = await this.accountsTokenRetrieveRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenFromJSON(jsonValue));
    }

    /**
     * Retrieve user\'s token.
     */
    async accountsTokenRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Token> {
        const response = await this.accountsTokenRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for accountsUsersList without sending the request
     */
    async accountsUsersListRequestOpts(requestParameters: AccountsUsersListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['companymembershipCompany'] != null) {
            queryParameters['companymembership__company'] = requestParameters['companymembershipCompany'];
        }

        if (requestParameters['hasApprovalPermission'] != null) {
            queryParameters['has_approval_permission'] = requestParameters['hasApprovalPermission'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/accounts/users/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve users information.
     */
    async accountsUsersListRaw(requestParameters: AccountsUsersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<User>>> {
        const requestOptions = await this.accountsUsersListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserFromJSON));
    }

    /**
     * A viewset to retrieve users information.
     */
    async accountsUsersList(requestParameters: AccountsUsersListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<User>> {
        const response = await this.accountsUsersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
